<template>
<v-app id="app">
    <!-- <v-app
    id="inspire"
    :style="{background: $vuetify.theme.themes[theme].background}"
  > -->
    <v-app-bar
      app
      elevation="0"
      clipped-left
    >

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>


      <v-container
        fluid
        class="py-0 ml-0 pl-0 fill-height"
      >
        <!-- <v-container fluid class="ma-0 pa-0 align-center fill-height red"> -->
        <!-- <v-col
            cols="2"
            xl="2"
            class="ma-0 pa-0"
          > -->
        <!-- <v-avatar :tile="true">
              <img
                :src="require('@/assets/logo5_and_text_transparent.png')"
                alt="logo"
              >
            </v-avatar> -->
        <v-img
          class="mx-2 hidden-md-and-down"
          src="@/assets/logo5_and_text_transparent.png"
          max-height="80"
          max-width="200"
          contain
        ></v-img>
        <!-- </v-col> -->
        <v-responsive
          height="50"
          class="pa-0 ml-0 ml-lg-5 align-center justify-start"
        >
          <v-container class="d-flex align-center">

            <HeaderPriceWidget />
            <HeaderRoiWidget class="ml-5 hidden-sm-and-down" />

          </v-container>
        </v-responsive>
        <!-- <v-responsive
          min-width="280"
          max-width="280"
          height="50"
          class="pa-0 pl-5 ml-5 ml-lg-5 align-center hidden-sm-and-down"
        >
        <v-row no-gutters>
          <v-col>
            <v-sheet color="transparent">
              ROI<sub>ETH</sub>  <span class="factor">{{ roiFactorUSD | toInt(2, 'x') }}</span>
            </v-sheet>
          </v-col>
          <v-col>
            <v-sheet color="transparent">
              ROI<sub>USD</sub>  <span class="factor">{{ roiFactorETH | toInt(2, 'x') }}</span>
            </v-sheet>
          </v-col>
        </v-row>



        </v-responsive> -->




        <!-- <v-col
            cols="3"
            class="blue ma-0 ml-2 pl-5 pa-0"
          >
          </v-col> -->
        <v-spacer></v-spacer>
        <v-responsive class="ma-0 pa-0 text-right pr-5 hidden-md-and-down">
          <v-btn
            :href="referralLink"
            color="#29abb5"
            target="_blank"
            @click="captureReferralLink('referrallink_header', referralLink); return false;"
            outlined
            elevation="2"
            class="hidden-xs-and-down mx-2"
          >
            10% BONUS ON STAKING
          </v-btn>

          <v-btn
            v-if="isMetaMaskConnected"
            color="#f4772e"
            outlined
            elevation="2"
            class="hidden-sm-and-down text-none mx-2"
          >
            <span class="mr-2">{{shortenedAccount}}</span>
          </v-btn>

          <v-btn
            v-else
            color="#f4772e"
            outlined
            elevation="2"
            class="hidden-sm-and-down"
            @click="connectMetamask"
          >
            Connect Metamask
          </v-btn>
        </v-responsive>
        <v-app-bar-nav-icon
          app
          class="hidden-lg-and-up mr-2"
          @click="buttons = !buttons"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-app-bar-nav-icon>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      elevation="0"
    >
      <v-container class="mt-0 px-3">
        <v-list color="transparent">
          <v-list-item
            v-for="[icon, text, link] in links1"
            :key="text"
            link
            dense
            :to="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="ml-2 mb-0 mt-3 caption">Data, Insights & Tools</div>
        <v-list
          color="transparent"
          class="pt-0 pb-3"
        >
          <v-list-item
            v-for="[icon, text, link] in links2"
            :key="text"
            link
            dense
            :to="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="ml-2 mb-0 mt-3 caption">Learning & Guides</div>
        <v-list
          color="transparent"
          class="pt-0 pb-3"
        >
          <v-list-item
            v-for="[icon, text, link] in links3"
            :key="text"
            link
            dense
            :to="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="ml-2 mb-0 mt-3 caption">Contracts</div>
        <v-list color="transparent pt-0 pb-3">
          <v-list-item
            v-for="[icon, text, link] in links5"
            :key="text"
            dense
            link
            target="_blank"
            :href="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="ml-2 mb-0 mt-3 caption">External Links</div>
        <v-list color="transparent pt-0 pb-3">
          <v-list-item
            v-for="[icon, text, link] in links4"
            :key="text"
            dense
            link
            target="_blank"
            :href="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="ml-2 mb-0 mt-3 caption">Other</div>
        <v-list color="transparent pt-0 pb-0">
          <v-list-item
            v-for="[icon, text, link] in links6"
            :key="text"
            dense
            link
            :to="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list color="transparent pt-0 pb-3">
          <v-list-item
            v-for="[icon, text, link] in links7"
            :key="text"
            dense
            link
            :href="link"
          >
            <v-list-item-icon class="mr-8">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-spacer></v-spacer>

        <v-list color="transparent">
          <v-list-item
            link
            dense
            @click="darkMode"
          >
            <v-list-item-icon class="mr-8">
              <v-icon v-if="!$vuetify.theme.dark">mdi-moon-waxing-crescent</v-icon>
              <v-icon v-else>mdi-white-balance-sunny</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-if="!$vuetify.theme.dark">Dark Mode</v-list-item-title>
              <v-list-item-title v-else>Light Mode</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-container>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="buttons"
      right
      app
      disable-resize-watcher
      floating
      width="300"
      height="170"
    >
      <div class="d-flex flex-column hidden-md-and-up pt-5">
        <!-- <v-responsive
          min-width="280"
          max-width="280"
          height="50"
          class="pa-0 pl-0 ml-2 ml-lg-0"
        > -->
        <!-- <v-row no-gutters>
          <v-col>
            <v-sheet color="transparent">
              ROI<sub>ETH</sub>  <span class="factor">1.79x</span>
            </v-sheet>
          </v-col>
          <v-col>
            <v-sheet color="transparent">
              ROI<sub>USD</sub>  <span class="factor">3.00x</span>
            </v-sheet>
          </v-col>
        </v-row> -->

        <HeaderRoiWidget class="mb-5 ml-5 hidden-md-and-up" />


        <!-- </v-responsive> -->


        <v-btn
          :href="referralLink"
          color="#29abb5"
          target="_blank"
          @click="captureReferralLink('referrallink_header', referralLink); return false;"
          outlined
          elevation="2"
          class="mx-2 px-2 mb-2"
        >
          10% BONUS ON STAKING
        </v-btn>

        <v-btn
          v-if="isMetaMaskConnected"
          color="#f4772e"
          outlined
          elevation="2"
          class="text-none mx-2 mb-2"
        >
          <span class="mr-2">{{shortenedAccount}}</span>
        </v-btn>

        <v-btn
          v-else
          color="#f4772e"
          outlined
          elevation="2"
          class="mx-2"
          @click="connectMetamask"
        >
          Connect Metamask
        </v-btn>
      </div>
    </v-navigation-drawer>



    <v-main>
      <v-container
        class="pa-md-2 pa-1 fill-height align-start"
        fluid
      >

        <router-view />
      </v-container>
    </v-main>
    <!-- <v-footer
      app
      height="72"
      inset
    >
    </v-footer> -->
    <v-footer
      app
      :class="{'responsive-footer-small': $vuetify.breakpoint.xsOnly}"
    >
      <cookie-consent />
      <v-container
        text-center
        class="wiseinfofooter mx-1"
      >
        <v-row no-gutters>
          <v-col
            cols="2"
            class="text-left"
          >
            <a href="mailto:wiseinfoio@gmail.com">Contact</a>
          </v-col>
          <v-col
            cols="8"
            class="text-center"
          >
            © Copyright 2020-2021 WISEinfo.io
          </v-col>
          <v-col
            cols="2"
            class="text-right"
          >
            <router-link to="/privacy">Privacy Policy</router-link>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import config from "@/utils/config.json";

  import {
    startDataPolling
  } from './utils/dataPoller';

  import {
    startWeb3Checks,
    connectWeb3,
  } from './utils/getWeb3';

  import HeaderPriceWidget from "@/components/header/HeaderPriceWidget.vue"
  import HeaderRoiWidget from "@/components/header/HeaderRoiWidget.vue"


  export default {
    name: "App",
    components: {
      HeaderPriceWidget,
      HeaderRoiWidget
    },
    data() {
      return {
        drawer: true,
        buttons: false,
        showMetamask: true,
        referralAccount: config.referralAccount,
        // roiFactorUSD: 1.666,
        // roiFactorETH: 1.777,
        // initialPriceETH: 55900.80344143941383017 / 260760440.016238701274314313,
        // initialPriceUSD: 55900.80344143941383017 / 260760440.016238701274314313 * 747.35,
        links1: [
          ['mdi-view-dashboard', 'Dashboard', '/dashboard'],
          ['mdi-account', 'Account Visualizer', '/account'],
        ],
        links2: [
          ['mdi-currency-usd', 'Price & Market', '/price'],
          ['mdi-alarm', 'Staking & Holding', '/staking'],
          ['mdi-alarm', 'Ladder Staker', '/ladderstaker'],
          ['mdi-chart-pie', 'Wise Supply', '/supply'],
          ['mdi-delete-alert', 'Penalties', '/penalties'],
          ['mdi-playlist-star', 'Top Lists', '/toplists'],
          ['mdi-newspaper', 'News', '/news'],
        ],
        links3: [
          ['mdi-shield-lock', 'Insurance Staking', '/insurancestaking'],
          ['mdi-help-network', 'How to get WISE', '/howtogetwise'],
          ['mdi-help-network', 'How to stake WISE', '/howtostakewise'],
          ['mdi-frequently-asked-questions', 'FAQ', '/faq'],
          ['mdi-account-multiple', 'Community Sites', '/community'],
        ],
        links4: [
          ['mdi-file', 'wisetoken.net', this.getReferralLink()],
          ['mdi-help-network', 'Whitepaper', this.getReferralLinkWhitepaper()],
        ],
        links5: [
          ['mdi-file-code', 'WISE Mainnet', "https://etherscan.io/address/0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6"],
          ['mdi-file-code', 'WISE Testnet', "https://ropsten.etherscan.io/address/0xa89Cb3AA23F7d85DEF5dCCdb73450aE236AFEe61"],
          ['mdi-file-code', 'Insurance Mainnet', "https://etherscan.io/address/0x7924a6d4d5994cae4c82481eee253e342437e656"],
          ['mdi-file-code', 'Insurance Testnet', "https://ropsten.etherscan.io/address/0x05e90f4fAe5b0093dD322dafd699586570Fba474"],
          ['mdi-file-code', 'LT Mainnet', "https://etherscan.io/address/0xfef0d2f3a79b4338d8418003dd9df89281242063"],
          ['mdi-file-code', 'LT Testnet', "https://ropsten.etherscan.io/address/0xfafbfc24695178f74f158f70bd7ea6162d836a18"],
        ],
        links6: [
          ['mdi-alert', 'Disclaimer', "/disclaimer"],
          ['mdi-file-lock', 'Privacy Policy', "/privacy"],
        ],
        links7: [
          ['mdi-email', 'Contact', "mailto:wiseinfoio@gmail.com"],
        ],
      }
    },
    computed: {
      mini() {
        return this.$vuetify.breakpoint.mdAndDown;
      },
      testnet() {
        return process.env.VUE_APP_ENVIRONMENT === "development";
      },
      getColor() {
        let color = this.testnet ? "#3c44b1" : "primary"
        return color;
      },
      isLTPhase() {
        return this.$store.state.currentWiseDay > 0 && this.$store.state.currentWiseDay <= 50;
      },
      shortenedAccount() {
        let account = this.account;
        return account.slice(0, 6) + "...." + account.slice(-4);
      },
      account() {
        return this.$store.state.web3.account;
      },
      referralLink() {
        return "https://wisetoken.net/?w=" + config.referralAccount;
      },
      referralLinkWhitepaper() {
        return "https://wisetoken.net/teal/?w=" + config.referralAccount;
      },
      isMetaMaskConnected() {
        return this.$store.state.web3.connected;
      },
      theme() {
        return (this.$vuetify.theme.dark) ? 'dark' : 'light'
      },
    },
    async created() {
      this.drawer = !this.mini;
      startDataPolling();
      startWeb3Checks();
    },
    mounted() {
      this.restoreDarkModeFromLocalStorage();
    },
    methods: {
      restoreDarkModeFromLocalStorage() {
        const theme = localStorage.getItem("dark_theme");
        if (theme) {
          if (theme === "true") {
            this.$vuetify.theme.dark = true;
          } else {
            this.$vuetify.theme.dark = false;
          }
        } else if (
          window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
          this.$vuetify.theme.dark = true;
          localStorage.setItem(
            "dark_theme",
            this.$vuetify.theme.dark.toString()
          );
        }
      },
      getReferralLink() {
        return "https://wisetoken.net/?w=" + config.referralAccount;
      },
      getReferralLinkWhitepaper() {
        return "https://wisetoken.net/teal/?w=" + config.referralAccount;
      },
      // calculateRoiFactors() {
      //   this.roiFactorUSD = this.currentPriceUSD / this.initialPriceUSD;
      //   this.roiFactorETH = this.currentPriceETH / this.initialPriceETH;
      // },
      connectMetamask() {
        console.log("connecting metamask");
        connectWeb3();
      },
      scrollToTop() {
        window.scrollTo(0, 0);
      },
      captureReferralLink(category, url) {
        this.$ga.event(category, 'click', url, 1234);
      },
      darkMode() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());

      }
    }
  };
</script>
<style lang="scss">
$cookieconstent-background: #555555 !default;
$cookieconstent-compliance-color: #fff !default;
$cookieconstent-compliance-background: #237afc !default;
$cookieconstent-compliance-border: 2px solid currentColor !default;

@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
// @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";
</style>
<style>
  #app {
    font-family: Montserrat, Roboto, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .responsive-footer-small {
    font-size: 0.6em
  }

  .anchor {
    display: block;
    position: relative;
    top: -70px;
    visibility: hidden;
  }

  .privacyLink {
    color: white !important
  }

  .wiseinfofooter {
    max-width: 100% !important;
  }

  .cookie-consent-link {
    color: white !important;
  }

  .container {
    width: 100%;
  }

  .container--fluid {
    min-width: 100%;
  }

  .theme--dark.v-application {
    background-color: #555555 !important;
  }

  .theme--light.v-application {
    background-color: #E5E5E5 !important;
  }

  .v-navigation-drawer.v-navigation-drawer--fixed.v-navigation-drawer--open.theme--light {
    background-color: #F5F5F5 !important;
  }

  .v-navigation-drawer.v-navigation-drawer--fixed.v-navigation-drawer--open.theme--dark {
    background-color: #272727 !important;
  }
</style>
